import { TrackJS } from 'trackjs'

const TrackJSLogger = (store: any) => (next: any) => (action: any) => {
  try {
    TrackJS.console.log(action)
    return next(action)
  } catch (err) {
    console.warn(store.getState())
    if (err instanceof Error) {
      TrackJS.track(err)
    } else {
      console.warn(err)
    }
  }
}

export default TrackJSLogger
